import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SiteParamsState {
  params: any; 
}

const initialState: SiteParamsState = {
  params: null,
};

const siteSliceParams = createSlice({
  name: 'siteParams',
  initialState,
  reducers: {
    setSiteParams(state, action: PayloadAction<any>) {
      state.params = action.payload;
    },
  },
});

export const { setSiteParams } = siteSliceParams.actions;
export default siteSliceParams.reducer;
